import React from 'react';
import { Text, Pane, TextInput, Flex } from '@leverege/ui-elements';
import StringUtil from '@leverege/string-util';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.twoFactor.LoginModal');
export default function LoginModal({
  error,
  onChange,
  password,
  variant
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "twoStepTitle|title"
  }, t('title')), /*#__PURE__*/React.createElement(Text, null, t('subtitle')), error && /*#__PURE__*/React.createElement(Pane, {
    variant: variant
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: `${variant}|rowM`
  }, /*#__PURE__*/React.createElement(Text, {
    variant: variant,
    hint: t('password')
  }, /*#__PURE__*/React.createElement("i", {
    className: "lv lv-system-error"
  })), /*#__PURE__*/React.createElement(Text, {
    variant: variant
  }, StringUtil.capitalizeAll(error)))), /*#__PURE__*/React.createElement(TextInput, {
    hint: t('hint'),
    value: password,
    onChange: onChange,
    variant: "password|formInput",
    type: "password",
    autoComplete: "current-password",
    changeOnReturn: false
  }));
}